import { Icons } from '@/components/ui/Icons'
import { percent } from '@/lib/format'
import type { Trend } from './siteStatus'
import styles from './TrendIcon.module.css'

/** Arrow comparing a success ratio with the previous period; the tooltip carries the earlier value. */
export function TrendIcon({ trend, reference }: { trend: Trend; reference: number | null }) {
  const title = reference === null ? 'No 36-hour reference' : `${percent(reference)} 36 hours ago`
  const icon = trend === 'up' ? <Icons.ArrowUp size={14} /> : trend === 'down' ? <Icons.ArrowDown size={14} /> : trend === 'flat' ? <Icons.ArrowRight size={14} /> : <Icons.Question size={14} />
  return (
    <span className={`${styles.trend} ${styles[trend]}`} title={title}>
      {icon}
    </span>
  )
}
